var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendationSystems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#1EE0D7;}\r\n\t.st2{fill:#00CABD;}\r\n\t.st3{fill:#465064;}\r\n\t.st4{fill:#FFDC28;}\r\n\t.st5{fill:#63B7FF;}\r\n\t.st6{fill:#4A9FFF;}\r\n\t.st7{fill:#50FAF0;}\r\n\t.st8{fill:#FA9537;}\r\n\t.st9{fill:#FFF56E;}\r\n\t.st10{fill:#F0F0F0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,20.2H44c-1.8,0-3.2,1.4-3.2,3.2v38.4h40V23.4C80.8,21.6,79.3,20.2,77.6,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.6,19.4H44c-2.2,0-4,1.8-4,4v43.2c0,2.2,1.8,4,4,4h33.6c2.2,0,4-1.8,4-4V23.4 C81.6,21.2,79.8,19.4,77.6,19.4z M41.6,61V23.4c0-1.3,1.1-2.4,2.4-2.4h33.6c1.3,0,2.4,1.1,2.4,2.4V61H41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.4,66.6h-3.2c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h3.2c0.4,0,0.8,0.4,0.8,0.8S70.8,66.6,70.4,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.4,66.6h-3.2c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h3.2c0.4,0,0.8,0.4,0.8,0.8S54.8,66.6,54.4,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64,24.2h-6.4c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8H64c0.4,0,0.8,0.4,0.8,0.8 C64.8,23.9,64.4,24.2,64,24.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.2,
    cy: 23.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.2,64.2h3.2c0.9,0,1.6,0.7,1.6,1.6l0,0c0,0.9-0.7,1.6-1.6,1.6h-3.2c-0.9,0-1.6-0.7-1.6-1.6l0,0 C57.6,64.9,58.3,64.2,59.2,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.8,26.8l1.2,2.5l2.8,0.4l-2,1.9l0.5,2.8l-2.5-1.3l-2.5,1.3l0.5-2.8l-2-1.9l2.8-0.4L48.8,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.8,26.8l1.2,2.5l2.8,0.4l-2,1.9l0.5,2.8l-2.5-1.3l-2.5,1.3l0.5-2.8l-2-1.9l2.8-0.4L60.8,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.8,26.8l1.2,2.5l2.8,0.4l-2,1.9l0.5,2.8l-2.5-1.3l-2.5,1.3l0.5-2.8l-2-1.9l2.8-0.4L72.8,26.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.8,45h-5.6c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h5.6c0.4,0,0.8,0.4,0.8,0.8 C65.6,44.6,65.2,45,64.8,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.8,41h-5.6c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h5.6c0.4,0,0.8,0.4,0.8,0.8 C65.6,40.6,65.2,41,64.8,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.8,57h-5.6c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h5.6c0.4,0,0.8,0.4,0.8,0.8 C65.6,56.6,65.2,57,64.8,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.8,53h-5.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h5.6c0.4,0,0.8,0.4,0.8,0.8S65.2,53,64.8,53z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.8,37.8H56v8H44.8V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.4,39.4H56v6.4h-9.6V39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M44.8,49.8H56v8H44.8V49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.4,51.4H56v6.4h-9.6V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.4,40.2L48,42.6v3.2h4.8v-3.2L50.4,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.8,53h4v4.8h-4V53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.4,53h2.4v4.8h-2.4V53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M48.8,54.6H56v3.2h-7.2V54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.3,51.6l2.3-2.3l6.2,6.2l-2.3,2.3L76.3,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82,58.4l3.4-3.4l0,0l4,4c0.9,0.9,0.9,2.5,0,3.4c-0.9,0.9-2.5,0.9-3.4,0L82,58.4L82,58.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 75.2,
    cy: 48.2,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 76,
    cy: 49,
    r: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,57c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8C84,53.1,80,57,75.2,57z M75.2,41 c-4,0-7.2,3.2-7.2,7.2s3.2,7.2,7.2,7.2s7.2-3.2,7.2-7.2C82.4,44.2,79.1,41,75.2,41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationSystems);
export default __webpack_public_path__ + "static/media/RecommendationSystems.f9810da0498b21d6dc3cb36ffbbfe5d5.svg";
export { ForwardRef as ReactComponent };